import React, { useState } from "react"
import "./documentsPartner.scss"

const DOCUMENTS = [
  {
    title: "Driver Documents",
    items: [
      "Valid Commercial Driving License (LMV / Transport badge)",
      "Aadhaar Card (identity proof)",
      "PAN Card (mandatory for TDS)",
      "Passport-size Photograph",
      "Bank Account Details -passbook or cancelled cheque (for weekly payouts)",
      "Police Verification Certificate",
    ],
  },
  {
    title: "Vehicle Documents",
    items: [
      "Registration Certificate (RC Book) -vehicle not older than 8 years",
      "All India Tourist Permit or valid state outstation permit",
      "Commercial Vehicle Insurance (valid & comprehensive)",
      "Pollution Under Control (PUC) Certificate",
      "Fitness Certificate (for commercial vehicles)",
      "Vehicle Photos -front, back, and interior (AC mandatory)",
    ],
  },
  {
    title: "Fleet Owner / Company Documents",
    items: [
      "GST Registration Certificate (mandatory -Pulpit issues TDS Form 16A quarterly)",
      "Company Registration / Trade License",
      "Fleet Owner Aadhaar & PAN Card",
      "Authorization Letter for each vehicle in the fleet",
      "All driver documents for each assigned driver",
      "Minimum 1 own registered commercial vehicle (no sub-contracted fleet)",
    ],
  },
]

const DocumentsPartner = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? -1 : idx)
  }

  return (
    <section className="documents-partner">
      <div className="documents-partner__container">
        <h2 className="documents-partner__heading">
          Cab Driver Registration <span>Documents</span>
        </h2>
        <p className="documents-partner__subheading">
          Keep these documents handy to complete your cab driver registration online
        </p>

        <div className="documents-partner__accordion">
          {DOCUMENTS.map((doc, i) => (
            <div
              className={`documents-partner__panel ${openIndex === i ? "documents-partner__panel--open" : ""}`}
              key={i}
            >
              <button
                className="documents-partner__panel-header"
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
              >
                <span className="documents-partner__panel-title">{doc.title}</span>
                <span className="documents-partner__panel-icon">
                  {openIndex === i ? "−" : "+"}
                </span>
              </button>
              <div className="documents-partner__panel-body">
                <ul className="documents-partner__list">
                  {doc.items.map((item, j) => (
                    <li key={j} className="documents-partner__list-item">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#21A5A0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default DocumentsPartner
